module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/661lCN/tc-custom/9781460322697.jpg?1704717814994",
      "alt": "This image is the cover for the book Prince She Never Knew & Kholodov's Last Mistress, The Diomedi Heirs"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prince She Never Knew & Kholodov's Last Mistress, The Diomedi Heirs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Prince She Never Knew "), _c('br'), _c('br'), _vm._v("Behind the royal wedding  "), _c('br'), _c('br'), _vm._v("While the world believes her romance with Prince Leo Diomedi, Alyse knows it's just a calculated sham. "), _c('br'), _c('br'), _vm._v("Yet beneath his icy exterior, Leo's kisses give Alyse a taste of the man behind the crown But will their fairy tale survive the headlines threatening to rip everything apart? "), _c('br'), _c('br'), _vm._v("Kholodov's Last Mistress "), _c('br'), _c('br'), _vm._v("An innocent in Moscow "), _c('br'), _c('br'), _vm._v("Cold-hearted Sergei Kholodov was shocked by Hannah Pearl's wide-eyed approach to the world. Fearing her effect on him, Sergei obliterated all traces of her from his life. "), _c('br'), _c('br'), _vm._v("One year later, he returns. Unable to escape her memory, could one more night allow him to forget her forever?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Hewitt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kate Hewitt has worked a variety of different jobs, from drama teacher to editorial assistant to youth worker, but writing romance is the best one yet. She also writes women's fiction and all her stories celebrate the healing and redemptive power of love. Kate lives in a tiny village in the English Cotswolds with her husband, five children, and an overly affectionate Golden Retriever.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0